module.exports = __webpack_public_path__ + "img/cut_height2.c14e2ea9.png";